'use strict';
const ContactService  = require('./contact.service.js');
const DocumentService = require('./document.service.js');
const HomeService     = require('./home.service.js');
const NewsService     = require('./news.service.js');
const StandardService = require('./standard.service.js');

const routes = [
  {
    path: '/',
    service: HomeService
  },
  {
    path: '/library',
    title: 'Library',
    service: StandardService
  },
  {
    path: '/news',
    title: 'News',
    service: NewsService
  },
  {
    path: '/about',
    title: 'About',
    service: StandardService
  },
  {
    path: '/contact',
    title: 'Contact',
    service: ContactService
  },
  {
    path: '/library/:id',
    type: 'document',
    service: DocumentService
  },
  {
    path: '/news/:slug',
    type: 'article',
    title: 'News',
    service: StandardService
  }
];

module.exports = routes;



// WEBPACK FOOTER //
// ./src/js/routes.js